<div class="mx-toolbar">
  <div class="mx-search">
    <mat-icon>search</mat-icon>
    <input
      type="search"
      [value]="query"
      (input)="onQueryChange($event)"
      [placeholder]="'Search' | translate"
      [attr.aria-label]="'Search permission objects' | translate" />
    </div>

    @if (hasQuery) {
      <span class="pin">
        <mat-icon>sell</mat-icon> {{ 'Search kept while you switch roles' | translate }}
      </span>
    }

    <div class="seg-filter" role="group" [attr.aria-label]="'Filter objects' | translate">
      <button type="button" [attr.aria-pressed]="filter === 'all'" (click)="onSetFilter('all')">{{ 'All' | translate }}</button>
      <button type="button" [attr.aria-pressed]="filter === 'granted'" (click)="onSetFilter('granted')">{{ 'Granted' | translate }}</button>
      <button type="button" [attr.aria-pressed]="filter === 'changed'" (click)="onSetFilter('changed')">{{ 'Changed' | translate }}</button>
    </div>

    <button type="button" class="link-btn" (click)="onToggleAll()">
      {{ (allCollapsed ? 'Expand all' : 'Collapse all') | translate }}
    </button>

    <div class="mx-count">
      <b>{{ totalObjects }}</b> {{ 'objects' | translate }} · <b>{{ grantedObjects }}</b> {{ 'granted' | translate }}
    </div>
  </div>

  <div class="mx-scroll">
    <div class="mx-grid" role="table" (keydown)="onGridKeydown($event)">
      <div class="mx-row mx-head" role="row">
        <div class="mx-head-object">
          {{ 'Object' | translate }}
        </div>
        @for (col of columns; track trackByColumnDef($index, col)) {
          <div
            class="mx-head-verb"
            [title]="col.description | translate"
            [attr.aria-label]="'{{label}} — {{description}}' | translate: { label: (col.label | translate), description: (col.description | translate) }">
            {{ col.label | translate }}
          </div>
        }
      </div>

      @for (group of groups; track trackByCategory($index, group)) {
        <div class="mx-row mx-group" [class.collapsed]="group.collapsed" role="row">
          <button type="button" class="mx-group-name" [attr.aria-expanded]="!group.collapsed" (click)="onToggleGroup(group)">
            <mat-icon class="chev">expand_more</mat-icon>
            <span class="mx-group-title">{{ group.displayName }}</span>
            <span class="mx-group-count" [class.some]="group.grantedCount > 0">
              {{ group.grantedCount }} / {{ group.totalCount }}
            </span>
          </button>
          @for (bulk of group.bulkCells; track trackByBulkColumn($index, bulk)) {
            <div class="mx-cell mx-group-bulk">
              <span
                class="cbx"
                role="checkbox"
                tabindex="0"
                [class.mixed]="bulk.state === 'mixed'"
                [attr.aria-checked]="bulk.state === 'mixed' ? 'mixed' : bulk.state === 'on'"
                [attr.aria-label]="'Set {{verb}} for every object in this group' | translate: { verb: (bulk.label | translate) }"
                (click)="onToggleBulk(group, bulk)"
                (keydown.enter)="onToggleBulk(group, bulk)"
                (keydown.space)="$event.preventDefault(); onToggleBulk(group, bulk)">
              </span>
            </div>
          }
        </div>
        @if (!group.collapsed) {
          @for (row of group.rows; track trackByObjectId($index, row); let odd = $odd) {
            <div class="mx-row mx-obj" [class.alt]="odd" [class.is-dirty]="row.isDirty" role="row">
              <div class="mx-label">
                <div class="mx-label-main">
                  <span class="mx-label-name">{{ row.name }}</span>
                  @if (row.isCustom) {
                    <span class="pill custom">{{ 'custom' | translate }}</span>
                  }
                </div>
                @if (row.description) {
                  <div class="mx-label-desc" [title]="row.description">{{ row.description }}</div>
                }
              </div>
              @for (cell of row.cells; track trackByColumn($index, cell)) {
                <div class="mx-cell">
                  <span
                    class="cbx"
                    role="checkbox"
                    [class.disabled]="cell.disabled"
                    [attr.tabindex]="cell.disabled ? -1 : 0"
                    [attr.aria-checked]="cell.checked"
                    [attr.aria-disabled]="cell.disabled"
                    [attr.title]="cell.disabled ? (cell.disabledReason | translate) : null"
              [attr.aria-label]="cell.disabled
                ? ('{{label}} {{name}} — {{reason}}' | translate: { label: (cell.label | translate), name: row.name, reason: (cell.disabledReason | translate) })
                : ((cell.label | translate) + ' ' + row.name)"
                    (click)="onToggleColumn(row, cell)"
                    (keydown.enter)="onToggleColumn(row, cell)"
                    (keydown.space)="$event.preventDefault(); onToggleColumn(row, cell)">
                  </span>
                </div>
              }
            </div>
          }
        }
      }

      @if (!groups.length) {
        <div class="mx-empty">
          @if (totalObjects) {
            {{ 'No objects match this search or filter.' | translate }}
            <button type="button" class="link-btn" (click)="clearAll()">{{ 'Clear search and filters' | translate }}</button>
          } @else {
            {{ 'No permission objects to display.' | translate }}
          }
        </div>
      }
    </div>
  </div>
